export default "__VITE_ASSET__0bd6e2d2__"